type SubsectionProps = {
    title: string;
    description: string;
};

function Subsection({ title, description }: SubsectionProps): JSX.Element {
    return (
        <section className="grid gap-y-1">
            <label className="text-xs font-medium text-gray-800 dark:text-gray-200">{title}</label>
            <p className="text-xs font-normal text-gray-600 dark:text-gray-400">{description}</p>
        </section>
    );
}

export default Subsection;
